"use client"

import { useState, useEffect } from "react"
import "./styles.css"

const CharacterDisplay = ({ character, data, isSelected, onSelect }) => {
  const [showAlternateImage, setShowAlternateImage] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (!isSelected) {
      setShowAlternateImage(false)
    }
    if (isSelected) {
      setIsAnimating(true)
      const timer = setTimeout(() => {
        setIsAnimating(false)
      }, 600)
      return () => clearTimeout(timer)
    }
  }, [isSelected])

  const handleImageClick = () => {
    setShowAlternateImage(!showAlternateImage)
    onSelect()
  }

  // Determine which image to show
  const imageToShow =
    showAlternateImage && isSelected && data.alternateImage ? data.alternateImage : data.image || "/placeholder.svg"

  return (
    <div
      style={{
        backgroundColor: data.backgroundColor,
        padding: isSelected ? "1rem 2rem" : "0",
        // transform:`scale(${isSelected ? 1.2 : 1})`,
      }}
      className={`mobile-character-display ${isSelected ? "mobile-selected" : ""} ${isAnimating ? "mobile-animating" : ""}`}
    >
      <div className={`mobile-character-image-container ${isSelected ? "mobile-selected" : ""}`} onClick={handleImageClick}>
        <div className={`mobile-image-wrapper ${isSelected ? "mobile-selected" : ""}`}>
          <img
            src={imageToShow || "/placeholder.svg"}
            alt={`${character.charAt(0).toUpperCase() + character.slice(1)} Character`}
            className={`mobile-character-image ${isSelected ? "mobile-selected" : ""}`}
            style={{
              objectFit: "contain",
              borderRadius: "0.85rem",
              width: "100%",
              // transform: `scale(${isSelected ? 1.2 : 1})`,
            }}
          />
        </div>
      </div>

      {isSelected && showAlternateImage && (
        <div className="mobile-character-details">
          {/* <h1 className="mobile-character-name">{data.name}</h1> */}
          {/* <p className="mobile-character-description">{data.description}</p> */}
          <p className="mobile-character-name" dangerouslySetInnerHTML={{ __html: data.name }} />
          <p className="mobile-character-description" dangerouslySetInnerHTML={{ __html: data.description }} />
        </div>
      )}
    </div>
  )
}

export default CharacterDisplay
